import { render } from "./FormThumbnail.vue?vue&type=template&id=4a57fd92&scoped=true"
import script from "./FormThumbnail.vue?vue&type=script&lang=js"
export * from "./FormThumbnail.vue?vue&type=script&lang=js"

import "./FormThumbnail.vue?vue&type=style&index=0&id=4a57fd92&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4a57fd92"

export default script